
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic10 as ObiHydraulic10Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-10.js';
 
 
 

 
 export const ObiHydraulic10 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-10',
   elementClass: ObiHydraulic10Element,
   events: {
     
   }
  });
 
 